import { Tag, type TableColumnsType } from 'antd';
import { CatalogueRowActions } from './CatalogueRowActions';
import type { ZoneKind } from './reference-data.api';

interface BuildZoneKindColumnsArgs {
  onEdit: (row: ZoneKind) => void;
  onDeactivate: (row: ZoneKind) => Promise<void>;
  onReactivate: (row: ZoneKind) => Promise<void>;
}

export function buildZoneKindColumns({ onEdit, onDeactivate, onReactivate }: BuildZoneKindColumnsArgs): TableColumnsType<ZoneKind> {
  return [
    { title: 'Code', dataIndex: 'code', key: 'code', render: (code: string) => <span className="font-mono text-xs">{code}</span> },
    { title: 'Name', dataIndex: 'name', key: 'name' },
    {
      title: 'Status',
      dataIndex: 'isActive',
      key: 'isActive',
      render: (isActive: boolean) => <Tag color={isActive ? 'success' : 'default'}>{isActive ? 'Active' : 'Inactive'}</Tag>,
    },
    {
      title: '',
      key: 'actions',
      render: (_, row) => <CatalogueRowActions row={row} onEdit={onEdit} onDeactivate={onDeactivate} onReactivate={onReactivate} />,
    },
  ];
}
